import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { CheckCircle2, Circle, MapPin } from 'lucide-react';

export default function TransitionTimeline() {
  // TODO: Replace with actual timeline data
  const milestones = [
    { id: 1, title: 'Plan Created', date: 'Week 1', status: 'complete' },
    { id: 2, title: 'First Module Complete', date: 'Week 4', status: 'complete' },
    { id: 3, title: 'First Project Started', date: 'Week 8', status: 'current' },
    { id: 4, title: 'Resume V1 Complete', date: 'Week 16', status: 'upcoming' },
    { id: 5, title: 'Job Ready', date: 'Week 24', status: 'upcoming' },
  ];

  return (
    <Card accent className="bg-card shadow-md border-border hover:shadow-lg transition-shadow">
      <CardHeader>
        <CardTitle className="text-lg font-bold text-primary flex items-center gap-2">
          <div className="p-1.5 rounded-md bg-primary/10">
            <MapPin className="h-5 w-5 text-primary" />
          </div>
          Transition Timeline
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="relative">
          {/* Vertical timeline line */}
          <div className="absolute left-3 top-2 bottom-2 w-0.5 bg-gradient-to-b from-primary via-primary/30 to-border transition-colors" />
          
          <div className="space-y-6">
            {milestones.map((milestone) => (
              <div key={milestone.id} className="flex items-start gap-4 relative group">
                <div className={`z-10 flex-shrink-0 p-1 rounded-full ${
                  milestone.status === 'complete' 
                    ? 'bg-primary/10' 
                    : milestone.status === 'current'
                    ? 'bg-secondary/10 ring-2 ring-secondary/30'
                    : 'bg-muted'
                } transition-all`}>
                  {milestone.status === 'complete' ? (
                    <CheckCircle2 className="h-5 w-5 text-primary" />
                  ) : (
                    <Circle className={`h-5 w-5 ${
                      milestone.status === 'current' ? 'fill-secondary text-secondary' : 'text-muted-foreground'
                    }`} />
                  )}
                </div>
                <div className="flex-1 pb-2">
                  <div className="flex items-center justify-between">
                    <p className={`font-semibold ${
                      milestone.status === 'complete'
                        ? 'text-foreground'
                        : milestone.status === 'current'
                        ? 'text-secondary'
                        : 'text-muted-foreground'
                    } transition-colors`}>
                      {milestone.title}
                    </p>
                    {milestone.status === 'current' && (
                      <Badge variant="branch" className="text-xs">In Progress</Badge>
                    )}
                  </div>
                  <p className="text-xs text-muted-foreground mt-1">{milestone.date}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
